<template>
  <v-card height="280px" class="modelo-card" :class="[isSelected ? 'selected-border' : 'normal-border']" @click.native="$emit('update:selected', raffleType)">
    <v-container height="13px" class="pa-5 d-flex card-icon-background" fluid justify="center" align="center">
      <v-container height="112px" class="d-flex justify-center align-center pa-0">
        <v-img class="background-raffle-image" max-height="72" :src="imageUrl" contain :aspect-ratio="1 / 1"></v-img>
      </v-container>
    </v-container>
    <v-container height="50%" class="pa-0" fluid>
      <v-card-text>
        <div class="disable-user-select">
          <h3 class="body-2 mb-1 modelo">{{ text }}</h3>
          <div class="descricao" v-html="description" />
        </div>
      </v-card-text>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'RaffleTypeCard',
  props: {
    text: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    raffleType: {
      type: String,
      required: true,
    },
    selected: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    isSelected() {
      return Boolean(this.raffleType === this.selected)
    },
  },
}
</script>

<style lang="scss">
$tablet-size: 960px;
.modelo-card {
  cursor: pointer;
  border-radius: 50px;
  border-radius: 50px;
  &.selected-border {
    border: 2px solid $marca-1;
  }
  &.normal-border {
    margin: 2px;
  }
  .card-icon-background {
    background-color: $cinza-l90;

    .background-raffle-image > .v-image__image {
      background-size: auto;
    }
  }
  .modelo {
    font-size: 18px;
    font-weight: bold;
    color: $cinza-d20;
  }
  .descricao {
    .descricao-text {
      color: $cinza-l10;
    }
    .descricao-emphasis {
      color: $cinza-d10;
    }
  }
}
</style>
